<style lang="less" scoped>
.accounts-title {
  line-height: 40px;
  margin: 0;
  padding: 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: #000;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">APP版本管理</div>
      <!-- <div class="page-title-div">电站管理</div> -->
      <ZD-list-querys> </ZD-list-querys>
      <div class="page-action-btns flex">
        <!-- <button class="common-bg-button" @click="listAddFun()">新增开屏</button> -->
        <button class="common-bg-button" @click="getAppversionDialog">
          创 建
        </button>
        <button class="common-bg-button" @click="searchAppversion">
          查 看
        </button>
        <!-- <div class="flex-1"></div>
                <el-input size="small" style="width:320px;margin-right:10px;" class="list-serach-input" v-model="queryInfo.pileTypeName" placeholder="请输入充电桩型号名称" clearable></el-input>
                <button class="common-bg-button" @click="getListData(pagination,true)">搜索</button> -->
      </div>
      <div class="accounts-title">
        APP当前版本
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="currentListData" :stripe="true" class="list_tb" border>
          <el-table-column
            prop="versionNo"
            label="版本号"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="platform"
            label="运行平台"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.platform == "01"
                  ? "Android"
                  : scope.row.platform == "02"
                  ? "IOS": ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="versionUrl"
            label="下载路径"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="versionSize"
            label="文件大小"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="versionDesc"
            label="更新内容"
            min-width="170"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="forcedUpdate"
            label="是否强制更新"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.forcedUpdate == "02"
                  ? "是"
                  : scope.row.forcedUpdate == "01"
                  ? "否"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createdByName"
            label="创建人"
            min-width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdWhen"
            label="创建时间"
            min-width="120"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>

      <div class="accounts-title">
        APP历史版本
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="historyListData" :stripe="true" class="list_tb" border>
          <el-table-column
            prop="versionNo"
            label="版本号"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="platform"
            label="运行平台"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.platform == "01"
                  ? "Android"
                  : scope.row.platform == "02"
                  ? "IOS": ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="versionSize"
            label="文件大小"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="versionDesc"
            label="更新内容"
            min-width="170"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="forcedUpdate"
            label="是否强制更新"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.forcedUpdate == "02"
                  ? "是"
                  : scope.row.forcedUpdate == "01"
                  ? "否"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="updateVersionNo"
            label="升级版本号"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdByName"
            label="创建人"
            min-width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdWhen"
            label="创建时间"
            min-width="120"
            align="center"
          >
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="list-pagination">
          <ZD-pagination
            :pagination="pagination"
            v-on:pageUpdate="getListData"
          ></ZD-pagination>
        </div>
      </div>
      <el-dialog :title="title" width="40%" :visible.sync="addAppversionDialog" :before-close="handelClose">
        <el-form
          :model="addAppversionForm"
          :rules="rules"
          ref="addAppversionForm"
          label-width="120px"
        >
          <div class="flex">
            <el-form-item label="运行平台" prop="platformName">
              <el-select
                size="small"
                v-model="addAppversionForm.platformName"
                placeholder="请选择"
                @change="changePlatformName"
              >
                <el-option v-for="item in platformNameList" :key="item.value" :label="item.label" :value="item"></el-option>
                
              </el-select>
            </el-form-item>
            <el-form-item label="版本号    V" prop="versionNo">
              <el-input
                size="small"
                v-model="addAppversionForm.versionNo"
                placeholder=""
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex">
            <el-form-item label="强制更新" prop="forcedUpdateName">
              <el-select
                size="small"
                v-model="addAppversionForm.forcedUpdateName"
                placeholder="请选择"
                @change="changeForcedUpdate"
              >
                <el-option v-for="item in forcedUpdateNameList" :key="item.value" :label="item.label" :value="item"></el-option>
                
              </el-select>
            </el-form-item>
            <el-form-item label="文件大小" prop="versionSize">
              <div class="flex">
                <el-input
                  size="small"
                  v-model="addAppversionForm.versionSize"
                  placeholder=""
                ></el-input
                ><span style="margin: 0 10px;">M</span>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="下载路径" prop="versionUrl">
            <el-input
              style="width:90%;"
              size="small"
              v-model="addAppversionForm.versionUrl"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="更新内容" prop="versionDesc">
            <el-input
              style="width:90%;"
              size="small"
              type="textarea"
              :rows="8"
              show-word-limit
              maxlength="200"
              v-model="addAppversionForm.versionDesc"
              autocomplete="off"
            ></el-input>
            <br />
            <span
              v-if="title == '创建APP版本'"
              style="color:rgba(255, 0, 0, 0.541);"
              >注：创建新版本会覆盖当前版本</span
            >
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handelClose">取 消</el-button>
          <el-button
            type="primary"
            v-if="title == '创建APP版本'"
            @click="addAppversion('addAppversionForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      platformName:'',
      title: "创建APP版本",
      listData: [], // 表格数据
      currentListData: [], //当前版本表格数据
      historyListData: [], //历史版本表格数据
      addAppversionDialog: false,
      addAppversionForm: {},
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      platformNameList:[
      {
        label:'Android',
        value:'01',
      },
      {
        label:'IOS',
        value:'02',
      },
      
      ],
      forcedUpdateNameList:[ 
        {
          label:'是',
          value:'02',
        },
        {
          label:'否',
          value:'01',
        }
       
      ],
      rules: {
        platformName: [
          { required: true, message: "请选择运行平台", trigger: "change" },
        ],
        versionNo: [
          { required: true, message: "请输入版本号", trigger: "blur" },
        ],
        forcedUpdateName: [
          { required: true, message: "请选择是否强制更新", trigger: "change" },
        ],
        versionSize: [
          { required: true, message: "请输入文件大小", trigger: "blur" },
        ],
        versionDesc: [
          { required: true, message: "请输入下载路径", trigger: "blur" },
        ],
        versionUrl: [
          { required: true, message: "请输入更新内容", trigger: "blur" },
        ],
      },
      queryInfo: {
        //页码
        // bannerType: "03",
      },
      switchArr: [], //启用状态
      srcList: [], //大图地址
      switchUse: "02", //使用状态
    };
  },
  methods: {
    init() {
      this.getListData(this.pagination, true);
      this.getHistory();
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.versionSwitch = '01';
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.get(_, _.$A.appVersion.appversion, _.queryInfo).then((res) => {
        _.currentListData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },

    getHistory() {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.appVersion.getHistory,{}).then((res) => {
        _.historyListData = res.data.data ? res.data.data.content : [];

        _.$U.hideLoading(_);
      });
    },

    getAppversionDialog() {
      // let _=this
      this.title = "创建APP版本";
     
      
      this.addAppversionDialog = true;
     this.addAppversionForm = {}
     this.$nextTick(()=>{
      this.$refs.addAppversionForm.clearValidate()
     })
     
    },
    changeForcedUpdate(val){
      let _ = this;
      _.addAppversionForm.forcedUpdateName = val.label;
      _.addAppversionForm.forcedUpdate = val.value;
    },
    changePlatformName(val){
      console.log(val); 
      let _=this;
      if(_.title == '查看APP版本'){
        _.addAppversionForm = {}
        console.log(val.value);
       _.currentListData.forEach(item=>{
          if(val.value === item.platform){
            console.log(item);
            _.addAppversionForm = item
          }
        })
        console.log(_.addAppversionForm);
      }
      _.addAppversionForm.platformName = val.label;
      _.addAppversionForm.platform = val.value;
      
   
    },
    addAppversion(addAppversionForm) {
      this.$refs[addAppversionForm].validate((valid) => {
        if (valid) {
          let _ = this;
          _.$H
            .post(_, _.$A.appVersion.appversion, _.addAppversionForm)
            .then((res) => {
              _.getListData(_.pagination, true);
              _.getHistory()
              _.$U.hideLoading(_);
            });
          _.addAppversionDialog = false;
          _.$refs[addAppversionForm].clearValidate()
        } 
      });
    },
    searchAppversion() {
      let _ = this
      _.title = "查看APP版本";
      _.addAppversionForm = _.currentListData[0] || {}
      _.addAppversionDialog = true;
      
    },
    handelClose(){
      let _ = this;
      _.$refs.addAppversionForm.clearValidate()
      _.addAppversionForm = {}
      _.addAppversionDialog = false;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
